<script setup lang="ts">
import type { ShiftFilterType } from '../../model/shift-control/use-shift-filter.hook'
import type { TutorSlotStatus, TutorSlotType } from '@brighterly/lib-core-types/tutor/enums'

import { BadgeReservationType, BadgeSlotStatus } from '@shared/ui/badges'
import { AppSelect } from '@shared/ui/selects'

import { useShiftFilter, buildShiftFilterConfig } from '../../model/shift-control/use-shift-filter.hook'

defineOptions({
  name: 'SelectShiftFilter',
})

const props = defineProps<{
  type: ShiftFilterType
}>()

const {
  label,
  placeholder,
  disabled,
  options,
  modelValue,
} = useShiftFilter(buildShiftFilterConfig(props.type))
</script>

<template>
  <AppSelect
    v-model="modelValue"
    :options="options"
    :placeholder="placeholder"
    :label="label"
    :disabled="disabled"
    clearable
  >
    <template
      v-if="type !== 'sort-by'"
      #option="{ option }"
    >
      <BadgeReservationType
        v-if="type === 'reservation-type'"
        :status="option.value as TutorSlotType"
      />
      <BadgeSlotStatus
        v-else
        :status="option.value as TutorSlotStatus"
      />
    </template>

    <template
      v-if="type !== 'sort-by'"
      #selected="{ option }"
    >
      <BadgeReservationType
        v-if="type === 'reservation-type'"
        :status="option.value as TutorSlotType"
      />
      <BadgeSlotStatus
        v-else
        :status="option.value as TutorSlotStatus"
      />
    </template>
  </AppSelect>
</template>
